import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { strings } from '../../assets/strings/all';
import { UserContext } from '../../containers/Context/UserContext';

function ProfilePendingReview() {
  const { profile } = strings;
  const { logout } = useContext(UserContext);

  return (
    <div className="profile-pending-review">
      <h4 className="title-complete-profile">{profile.pending_review_title}</h4>
      <p className="muted-text" style={{ marginTop: '1rem', lineHeight: 1.6 }}>
        {profile.pending_review_message}
      </p>
      <p className="muted-text" style={{ marginTop: '0.75rem', lineHeight: 1.6 }}>
        {profile.pending_review_helper}
      </p>
      <div style={{ marginTop: '2rem' }}>
        <Button variant="outline-primary" onClick={logout}>
          {profile.sign_Out}
        </Button>
      </div>
    </div>
  );
}

export default ProfilePendingReview;
